import React, { useState, useEffect } from "react";
import "../DetailsViewComponet/DetailsViewContent.css";
import { useParams, useLocation } from "react-router-dom";
import { IoClose, IoCopyOutline, IoCheckmarkOutline } from "react-icons/io5";
import { loadStripe } from "@stripe/stripe-js";
import { toast } from "react-toastify";
import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
import axios from "axios";
import {
  Box,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  IconButton
} from "@mui/material";
// import { IoClose } from "react-icons/io5";
import { useAuth0 } from "@auth0/auth0-react";
import { NilCollaborationForm } from "../NilCollaborationForm/NilCollaborationForm";

const stripePromise = loadStripe("pk_test_6pRNASCoBOKtIshFeQd4XMUh");

const PlayerDetailPage = ({ setLoading }) => {
  const { playerId, teamId } = useParams();
  const [copied, setCopied] = useState(false);
 const copyPlayerLink = async () => {
  try {
     await navigator.clipboard.writeText(playerLinkHref);
     setCopied(true);
     toast.success(
       "Copy Athlete Link to promote the athlete’s profile and share it across social media networks.",
       { icon: "🔗" }
     );
     setTimeout(() => setCopied(false), 2000);
   } catch (e) {
    toast.error("Could not copy the link. Please try again.");
   }
 };
  const { search } = useLocation();

  // ---- Mode handling (mirrors Dashboard) ----
  const modeParam = new URLSearchParams(search).get("mode");
  const mode = ["both", "collab", "contribute"].includes(modeParam) ? modeParam : "both";
  const showContribute = mode !== "collab";
  const showCollab = mode !== "contribute";

  const [playerDetails, setPlayerDetails] = useState(null);
  const userLoginDetails = getIsUser();
  const { loginWithRedirect } = useAuth0();

  const handleLoginIn = async () => {
    await loginWithRedirect({
      appState: { returnTo: "/" }
    });
  };

  const [formData, setFormData] = useState({
    player_id: 0,
    playerName: "",
    donateAmount: 0,
    teamName: "",
    transferredFrom: 0,
    transferedTeamName: "",
    transferredTo: 0,
    paymentDetails: "",
  });

  // ---- Contribution modal ----
  const [open, setOpen] = useState(false);
  const [actionType, setActionType] = useState(null); // 'donate' currently

  const handleOpenModal = (playerDetails, key = "donate") => {
    setFormData({
      ...formData,
      player_id: playerDetails.player_id,
      playerName: playerDetails.player_name,
      teamName: playerDetails.team_name,
      transferredFrom: playerDetails?.team_id
    });
    setActionType(key);
    setOpen(true);
  };

  // ---- NIL Collaboration modal ----
  const [openRequest, setOpenRequest] = useState(null);
  const handleOpenModalRequest = (player) => {
    setOpenRequest(player);
  };

  const usdFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const [openSection, setOpenSection] = useState("one-time");
  const [oneTimeAmount, setOneTimeAmount] = useState(0);
  const [oneTimeOther, setOneTimeOther] = useState("");
  const [serviceType, setServiceType] = useState("general_contribution");


  const toggleSection = (section) => {
    setOpenSection(openSection === section ? "" : section);
  };

  // Build a clean, shareable player link
const siteBase =
  (process.env.REACT_APP_SITE_BASE?.replace(/\/$/, "")) || window.location.origin;

const playerSlug =
  (playerDetails?.player_name || "")
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^\w-]/g, "");

const playerLinkHref = `${siteBase}/${teamId}/${playerId}`;

let playerLinkHostLabel;
try {
  playerLinkHostLabel = new URL(siteBase).host; // "nil-collab" if that's your domain
} catch {
  playerLinkHostLabel = siteBase.replace(/^https?:\/\//, "");
}

const playerLinkText =
  playerSlug ? `https://${playerLinkHostLabel}/${playerSlug}` : `${playerLinkHostLabel}/${teamId}/${playerId}`;


  const handleDonationOnetime = () => {
    if (!oneTimeAmount) {
      toast.error("Please select or add donation amount.");
      return;
    }
    if (!serviceType) {
      toast.error("Please choose a NIL Service Type.");
      return;
    }
    let data = {
      amount: Number(oneTimeAmount),
      nil_service_type: serviceType,
      player_id: Number(formData?.player_id),
      player_name: formData?.playerName,
      team_id: Number(formData.transferredFrom) // include team_id
    };
    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    }

    const url = `${APIUrl()}/v1/create-checkout-session/one_time`;
    const option = {
      method: "POST",
      headers: { "X-API-Key": APIUrlToken() },
      data,
      url,
    };

    axios(option)
      .then((response) => {
        const coUrl = response?.data?.checkout_url || [];
        window.open(coUrl, "_blank");
      })
      .catch((error) => {
        console.error("Error creating one-time checkout:", error);
      });
  };

  const getPlayerDetails = () => {
    setLoading(true);
    const url = `${APIUrl()}/v1/get_player/${playerId}/${teamId}`;
    const options = {
      method: "GET",
      headers: { "X-API-Key": APIUrlToken() },
    };

    axios(url, options)
      .then((response) => {
        setLoading(false);
        setPlayerDetails(response?.data);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching player data:", error);
      });
  };

  useEffect(() => {
    getPlayerDetails();
  }, [playerId, teamId]);

  return (
    <div className="player-detail-card">
      <div className="player-header">
        <div className="player-info-box">
          <div>
            <img
              src={playerDetails?.image_url}
              alt={playerDetails?.image_url}
              className="player-image"
            />
            <h2 className="name-heading-detailspage">{playerDetails?.player_name}</h2>
          </div>
          <div className="player-info">
            <span className="boi-plus-data">
              <p>Birthplace: </p>
              {playerDetails?.birthplace}
            </span>
            <span className="boi-plus-data">
              <p>Gender: </p>
              {playerDetails?.gender}
            </span>
            <span className="boi-plus-data">
              <p>Height: </p>
              {playerDetails?.height}
            </span>
            <span className="boi-plus-data">
              <p>Weight: </p>
              {playerDetails?.weight}
            </span>
            <span className="boi-plus-data">
              <p>Class:</p> {playerDetails?.player_class}
            </span>
            <span className="boi-plus-data" style={{ display: "flex", alignItems: "center", gap: 8 }}>
  <p style={{ marginRight: 4 }}>Player Link:</p>
  <a
    href={playerLinkHref}
    target="_blank"
    rel="noopener noreferrer"
    style={{ wordBreak: "break-all" }}
  >
    {playerLinkText}
  </a>

  {/* Copy button with tooltip + visual feedback */}
  <Tooltip
    title="Copy Athlete Link to promote the athlete’s profile and share it across social media networks."
    placement="top"
    arrow
  >
    <IconButton
      aria-label="Copy player link"
      size="small"
      onClick={copyPlayerLink}
      sx={{
        ml: 0.5,
        border: "1px solid rgba(0,0,0,0.12)",
        borderRadius: "8px"
      }}
    >
      {copied ? <IoCheckmarkOutline size={16} /> : <IoCopyOutline size={16} />}
    </IconButton>
  </Tooltip>
</span>


          </div>
        </div>

        <div className="score">
          <div className="jursy-number">
            <div className="score-circle">{Math.round(playerDetails?.jersey_number)}</div>
          </div>
          <h4>Jersey Number</h4>
        </div>
      </div>

      <div className="player-stats">
        <div className="add-info-support-sec">
          <div className="additional-info">
            <h4>Additional Information</h4>
            <ul>
              <li>
                Player bio URL:{" "}
                <a
                  href={playerDetails?.player_bio_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {playerDetails?.player_bio_url}
                </a>
              </li>
              <li>
                Game logs URL:{" "}
                <a
                  href={playerDetails?.player_game_logs_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {playerDetails?.player_game_logs_url}
                </a>
              </li>
              <li>
                News URL:{" "}
                <a
                  href={playerDetails?.player_news_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {playerDetails?.player_news_url}
                </a>
              </li>
              <li>
                Profile URL:{" "}
                <a
                  href={playerDetails?.player_profile_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {playerDetails?.player_profile_url}
                </a>
              </li>
              <li>
                Splits URL:{" "}
                <a
                  href={playerDetails?.player_splits_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {playerDetails?.player_splits_url}
                </a>
              </li>
              <li>
                Stats URL:{" "}
                <a
                  href={playerDetails?.player_stats_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {playerDetails?.player_stats_url}
                </a>
              </li>
            </ul>
          </div>

          <div className="support-section">
            {showContribute && (
              <button
                className="donate-button"
                onClick={() => handleOpenModal(playerDetails, "donate")}
                disabled={!playerDetails}
              >
                Contribute Now
              </button>
            )}
            {showCollab && (
              <button
                className="donate-button outline"
                onClick={() => handleOpenModalRequest(playerDetails)}
                style={{ marginLeft: showContribute ? 12 : 0 }}
                disabled={!playerDetails}
              >
                NIL Collaboration Request
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Contribution modal only when that action was chosen & allowed */}
      <Modal
        open={open && actionType === "donate" && showContribute}
        onClose={() => setOpen(false)}
      >
        <div className="modal-container">
          <Box
            sx={{
              width: 700,
              p: 3,
              bgcolor: "white",
              borderRadius: 2,
              position: "relative",
            }}
          >
            <IoClose
              className="close-icon"
              size={24}
              onClick={() => setOpen(false)}
              style={{ position: "absolute", top: 10, right: 10, cursor: "pointer" }}
            />
            <h3 className="donatefor-mdl-head">
              Donation For <span className="color-dc">{formData.playerName}</span> ({formData.teamName})
            </h3>

            <div className="donation-container">
              {/* One-Time */}
              <div className="accordion">
                <div className="accordion-header" onClick={() => toggleSection("one-time")}>
                  <strong>One-Time Contribution</strong>
                  <span>{openSection === "one-time" ? "▼" : "▶"}</span>
                </div>
                <div className={`accordion-content ${openSection === "one-time" ? "open" : ""}`}>
                  <div className="donation-options">
                    <button className={oneTimeOther === "10" ? "selected" : ""} onClick={() => { setOneTimeAmount(10); setOneTimeOther("10"); }}>$10</button>
                    <button className={oneTimeOther === "20" ? "selected" : ""} onClick={() => { setOneTimeAmount(20); setOneTimeOther("20"); }}>$20</button>
                    <button className={oneTimeOther === "50" ? "selected" : ""} onClick={() => { setOneTimeAmount(50); setOneTimeOther("50"); }}>$50</button>
                    <button className={oneTimeOther === "100" ? "selected" : ""} onClick={() => { setOneTimeAmount(100); setOneTimeOther("100"); }}>$100</button>
                    <button className={oneTimeOther === "500" ? "selected" : ""} onClick={() => { setOneTimeAmount(500); setOneTimeOther("500"); }}>$500</button>
                    <button className={oneTimeOther === "1000" ? "selected" : ""} onClick={() => { setOneTimeAmount(1000); setOneTimeOther("1000"); }}>$1000</button>
                    <button className={oneTimeOther === "other" ? "selected" : ""} onClick={() => { setOneTimeOther("other"); setOneTimeAmount(); }}>Other</button>
                    {oneTimeOther === "other" ? (
                      <TextField
                        label="Contribution Amount"
                        name="donateAmount"
                        fullWidth
                        margin="normal"
                        type="number"
                        onChange={(e) => {
                          const val = parseInt(e.target.value, 10);
                          setOneTimeAmount(Number.isNaN(val) ? 0 : Math.max(0, val));
                        }}
                        value={oneTimeAmount}
                      />
                    ) : null}
                    <FormControl fullWidth margin="normal">
                      <InputLabel id="service-type-label">NIL Service Type</InputLabel>
                      <Select
                        labelId="service-type-label"
                        id="service-type"
                        value="general_contribution"
                        label="NIL Service Type"
                        disabled
                        IconComponent={() => null}
                      >
                        <MenuItem value="general_contribution">General Contribution</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <button className="donate-btn" onClick={handleDonationOnetime}>
                    Make One-Time Contribution
                  </button>
                </div>
              </div>

            </div>
          </Box>
        </div>
      </Modal>

      {/* NIL Collaboration Form modal (same as in cards) */}
      {showCollab && (
        <NilCollaborationForm openRequest={openRequest} setOpenRequest={setOpenRequest} />
      )}
    </div>
  );
};

export default PlayerDetailPage;
